import { Component, Input, OnInit } from '@angular/core';
import { Conforme } from '../../../models/api.models';

@Component({
  selector: 'app-conforme',
  templateUrl: './conforme.component.html',
  styleUrls: ['./conforme.component.scss'],
})
export class ConformeComponent implements OnInit {

  @Input() conforme: Conforme

  constructor() { }

  ngOnInit() {}

}
